export default __webpack_public_path__ + "97b0e192ca5a4c8888b3c90582a8649e.svg";